<template>
  <div class="dataset-label">
    <div class="pretrain-header header">
      <h3 class="title">图片标注</h3>
    </div>
    <div class="main">
      <div class="dataset-get">
        <div class="tool-wrap">
          <div class="select-tool">
            <span class="label">
              <i class="required">*</i>
              选择数据集：
            </span>
            <el-select
              class="select-box"
              v-model="datasetName"
              placeholder="请选择"
              filterable
              :disabled ="originTemp=='modelList'"
            >
              <el-option
                v-for="item in datasetOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="select-tool">
            <span class="label">
              <i class="required">*</i>
              选择数据集版本：
            </span>
            <el-select
              class="select-box"
              v-model="activeDataset"
              placeholder="请选择"
              filterable
              :disabled ="originTemp=='modelList'"
            >
              <el-option
                v-for="item in versionList"
                :key="item.datasetId"
                :label="item.version"
                :value="item.datasetId"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <el-button
          class="image-filtering-button"
          :class="{'events-disable':isRelease ==1}"
          type="primary"
          @click="onImageFiltering"
          v-show="activeDataset"
          >图像筛选</el-button
        >
      </div>

      <div class="condition-screening">
        <ul>
          <li
            v-for="(item, index) in conditionNav"
            :key="index"
            @click="onSelectRadio(index)"
          >
            <i
              :class="[
                selectCondition === index ? 'el-icon-check i-select' : '',
              ]"
            ></i>
            <span :class="[selectCondition === index ? 'span-select' : '']">{{
              item
            }}</span>
          </li>
        </ul>
      </div>

      <div class="bnts-tag">
        <button
          v-for="(opt, idx) in filterOptions.items"
          :class="[
            'btn-default',
            opt.name == filterOptions.filtered ? 'active' : '',
          ]"
          @click="getFilterType(opt.name)"
          :key="idx"
        >
          {{ opt.label }}
        </button>
        <!-- 提示语 -->
        <el-alert title="* 每个标签下的图片数量不少于40张" type="error">
        </el-alert>

        <!-- 图片上传按钮 -->
        <el-button
          type="primary"
          class="camera-upload btn-primary"
          :class="{'events-disable':isRelease ==1}"
          @click="onCameraAcquisition"
          v-show="activeDataset"
          >摄像头采集</el-button
        >
        <el-button
          type="primary"
          class="quote-upload btn-primary"
          :class="{'events-disable':isRelease ==1}"
          @click="quoteDataset"
          v-show="activeDataset"
          >引用数据集</el-button
        >
        <el-button
          type="primary"
          class="btn-upload btn-primary"
          :class="{'events-disable':isRelease ==1}"
          @click="uploadPictures"
          v-show="activeDataset"
          >本地上传</el-button
        >
      </div>
      <!-- 图片累计 -->
      <span class="dataset-pic-total">
        {{ filterOptions.filtered === 'tag' ? `累计${Pictures.total}张图片` : `累计${Pictures.total}张图片，${getTagLabelIdsNum}个图片标注` }}
      </span>
      <div class="group-tag">
        <a
          v-for="(item, idx) in filterOptData.data"
          :class="[
            'h-tag',
            filterOptions.items[filterOptions.filtered].filteredId.indexOf(item.id) > -1 ? 'active': '',
          ]"
          href="javascript:void(0);"
          @click="getFilterDetails(item.id)"
          :key="idx"
        >
          <span class="title"> {{ item.label }} </span>
          <!-- <i
            class="btn-del el-icon-close"
            @click.stop="removeFilterDetails(idx, item.id)"
          ></i> -->
        </a>
      </div>

      <div class="picture-box" v-show="display === 'picture'">
        <ul class="pictures">
          <li
            class="picture-item"
            v-for="(item, idx) in Pictures.records"
            :key="item.imgId || idx"
          >
            <i
              class="el-icon-edit-outline preview-position"
              @click="onPreviewPosition(item.imgId, idx)"
              title="编辑"
            ></i>
            <i
              class="icon-see-img"
              @click="onFilePreview(item.imgUrl)"
              title="预览"
            ></i>
            <figure>
              <img :src="photoBaseUrl + item.imgUrl" alt="" />
              <!-- 置灰膜层 -->
              <div class="film" v-if="item.isQualified == 1"></div>
            </figure>
            <div class="btns" v-if ="isRelease != 1">
              <button
                class="btn-delete"
                :class="{'events-disable':isRelease ==1}"
                @click="activeDeletePopup(item.imgId, idx)"
              >
                删除
              </button>
              <button
                class="btn-primary"
                :class="{'events-disable':isRelease ==1}"
                @click="activeRenamePopup(item.imgId, item.imgName, idx)"
              >
                重命名
              </button>
            </div>
            <div class="imageSizeText">
              <span>{{ item.imgWidth }}px*{{ item.imgHeight }}px</span>
              <!-- <span>{{item.imgSize}}</span> -->
              <span
                >{{ $util.fileSizeTranfor(item.imgSize) }}B{{
                  item.checked
                }}</span
              >
            </div>
            <!-- 勾选框 -->
            <el-checkbox
              class="checkbox"
              v-model="item.checked"
              @change="handleChecked(item, idx)"
            ></el-checkbox>
            <div class="title ellipsis" :title="item.imgName">
              {{ item.imgName }}
            </div>
          </li>
        </ul>
        <!-- 分页 -->
        <div class="pagination">
          <el-pagination
            @current-change="handleCurrentChange"
            background
            :current-page.sync="currentPage"
            :page-size="20"
            :pager-count="5"
            layout="slot, prev, pager, next"
            :total="this.Pictures.total"
            :hide-on-single-page="true"
          >
          </el-pagination>
        </div>
        <!-- 分割线 -->
        <div class="sep" title="切换到图片标注处理">
          <span class="switch" @click="switchDisplayMode">
            <i :class="['el-icon-d-arrow-right', display]"></i>
          </span>
        </div>
      </div>
      <div class="label-box" v-show="display === 'label'">
        <!-- 图片滑动 -->
        <img-slider
          class="picture-slider"
          :pictures="this.Pictures.records"
          :active-image="activeImage"
          @prev="sliderPrev"
          @next="sliderNext"
          @image-click="sliderImageHandle"
        />
        <!-- 分割线 -->
        <div class="sep" title="切换到图片查看管理">
          <span class="switch" @click="switchDisplayMode">
            <i :class="['el-icon-d-arrow-right', display]"></i>
          </span>
        </div>
        <div class="label-content">
          <!-- 置灰膜层 -->
          <div class="film" v-if="isQualifiedSelected"></div>
          <!-- 标注插件使用 -->
          <label-region
            :class="{'events-disable':isRelease ==1}"
            :image="regionImage"
            :labelList="regionLabel"
            :img-tag="ImgTag.records"
            :noTarget="noTarget"
            ref="labelRegion"
          >
            <template v-slot>
              <div class="label-region-tag">
                <span @click="addTagToCurrentRegion('无目标', noTarget)">{{ noTarget ? '取消清空标注' : '清空标注' }}</span>
                <button class="label-example" @click="activeExamplePopup">标注示例</button>
              </div>
            </template>
          </label-region>
          <div class="label-tag">
            <div class="top">
              <div class="title">标签</div>
              <button
                class="add-tag"
                :class="{'events-disable':isRelease ==1}"
                @click="activeAddTagPopup"
                title="添加标签"
              >
                +
              </button>
            </div>

            <div class="nav-checkbox">
              <ul>
                <li v-for="item in navCheckList" :key="item">
                  <!-- <i :class="[currentNavlabel.id === item.id ? 'el-icon-check i-select' : '']"></i> -->
                  <!-- <span :class="[currentNavlabel === item ? 'span-select' : '']">{{item}}</span> -->
                  <span><i @click="onSelectNavState(item)">{{ item }}</i></span>
                </li>
              </ul>
            </div>

            <ul class="list-tags">
              <!-- <li
                :class="['tag-list',{'events-disable':isRelease ==1}]"
                @click="addTagToCurrentRegion('无目标', noTarget)"
              >
                {{ noTarget ? '取消清空标注' : '清空标注' }}
              </li> -->
              <li
                class="tag-list"
                :class="{'events-disable':isRelease ==1}"
                v-for="(item, idx) in Label.records"
                @click="
                  addTagToCurrentRegion(item.labelName, item.labelId, item)
                "
                :key="idx"
                :style="{
                  background:
                    selentCurrentLabelId == item.labelId
                      ? 'rgba(76, 136, 255, 0.2)'
                      : '',
                }"
              >
                <div class="tag-list-left">
                  <i
                    :class="[item.labelState ? 'el-icon-check i-select' : '']"
                    @click.stop="onSelectLabel(item.labelId)"
                  ></i>
                  <!-- <span class="txt ellipsis">{{ item.labelName }}</span> -->
                  <tooltip-box
                    class="txt"
                    :textRef="'labelName'"
                    :textId="item.labelId"
                    :textRow="1"
                    :textName="item.labelName"
                    :placement="'top'"
                    :tooltipShow="false"
                  ></tooltip-box>
                </div>
                <div class="tools">
                  <!-- TODO:命名需要弹框 -->
                  <button
                    @click="
                      activeRenameLabelPopup(idx, item.labelId, item.labelName)
                    "
                  >
                    <icon-base v-bind="Icons.edite">
                      <icon-label />
                    </icon-base>
                  </button>
                  <!-- TODO:删除会删除标记 -->
                  <button @click="deleteLabelPopup(idx, item.labelId)">
                    <icon-base v-bind="Icons.delete">
                      <icon-delete />
                    </icon-base>
                  </button>
                </div>
              </li>
            </ul>
            <el-button
              type="primary"
              class="btn-primary btn-save"
              :class="{'events-disable':isRelease ==1}"
              @click="updateLabelTag"
            >
              保存
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹窗集 -->
    <div class="popup-list">
      <!-- 添加新标签 -->
      <gat-popup
        :class="['popup-add-tag', popupActive === 'add_tag' ? 'on' : 'off']"
        :title="'添加标签'"
        @cancel="cancelPopup"
        @confirm="addLabel"
      >
        <template v-slot:content>
          <div v-if="Label.records && Label.records.length < 15">
            <el-input
              placeholder="新的标签命名"
              v-model.trim="popupData.labelName"
              maxlength="20"
              show-word-limit
            />
            <p class="tip-list">
              <i class="required">*</i>单个数据集的标签数最多不超过15个。
            </p>
          </div>
          <div v-else>
            <p class="p-tip">
              <!-- <i class="required">*</i> -->
              单个数据集的标签数最多不超过15个哦~
            </p>
            <div class="button-row">
              <el-button type="primary" @click="cancelPopup"
                >我知道了</el-button
              >
            </div>
          </div>
        </template>
      </gat-popup>
      <!-- 删除 -->
      <gat-popup
        :class="[
          'popup-delete popup-delete-2',
          popupActive === 'delete' || popupActive === 'label_delete'
            ? 'on'
            : 'off',
        ]"
        :title="popupActive === 'delete' ? '删除图片' : '删除标签'"
        :primary-button="'删除'"
        @cancel="cancelPopup"
        @confirm="deletePicture"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <i class="icon-box">
                <icon-base
                  class="icon-info-help"
                  :icon-name="Icons.InfoHelp.iconName"
                  v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
              <span v-show="popupActive === 'label_delete'" class="title"
                >确定删除此标签及此标签全部图片标注吗？</span
              >
              <span v-show="popupActive === 'delete'" class="title"
                >确定删除此图片以及相关标注吗？</span
              >
            </div>
          </div>
        </template>
      </gat-popup>
      <!-- 重命名 -->
      <gat-popup
        :class="['popup-rename', popupActive === 'rename' ? 'on' : 'off']"
        :title="'重命名'"
        @cancel="cancelPopup"
        @confirm="renameOperate"
      >
        <template v-slot:content>
          <el-input
            placeholder="请输入重命名"
            v-model.trim="popupData.rename.value"
            maxlength="20"
            show-word-limit
          />
        </template>
      </gat-popup>
      <!-- 标注示例 -->
      <gat-popup
        :class="['popup-example', popupActive === 'example' ? 'on' : 'off']"
        :title="'标注示例'"
        @cancel="cancelPopup"
      >
        <template v-slot:content>
          <div class="example-box">
            <div class="label-column label-all">
              <div class="txt">
                同一张图中需要标注“<b>全部想要标识的目标区域</b>” <br />
                以“检测一张图中所有的猫”为例：
              </div>
              <img :src="Example.labelAllImg" alt="" />
            </div>
            <div class="label-column label-similar">
              <div class="txt">
                <b>标注图片需要和实际场景一致，</b>” <br />
                以实际场景为识别出“用手机在超市货架拍摄的图片”中有几层货架为例：
              </div>
              <img :src="Example.labelSimilarImg" alt="" />
            </div>
          </div>
        </template>
        <template v-slot:buttons>
          <span></span>
        </template>
      </gat-popup>
      <!-- 图片筛选弹窗 -->
      <gat-popup
        :class="[
          'popup-upload-image-filtering',
          popupActive === 'imageFiltering' ? 'on' : 'off',
        ]"
        :title="'参数设置'"
        @cancel="cancelPopup"
      >
        <template v-slot:content>
          <div class="image-filtering-parameter">
            <div class="parameter">
              <span>分辨率：</span>
              <span>
                宽度<el-input
                  v-model="parameter.minWidth"
                  @blur="onBlurParameter(parameter.minWidth)"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  maxlength="4"
                  size="small"
                  placeholder=""
                ></el-input
                >—<el-input
                  v-model="parameter.maxWidth"
                  @blur="onBlurParameter(parameter.maxWidth)"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  maxlength="4"
                  size="small"
                  placeholder=""
                ></el-input
                >px
              </span>
              <span>
                高度<el-input
                  v-model="parameter.minHeight"
                  @blur="onBlurParameter(parameter.minHeight)"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  maxlength="4"
                  size="small"
                  placeholder=""
                ></el-input
                >—<el-input
                  v-model="parameter.maxHeight"
                  @blur="onBlurParameter(parameter.maxHeight)"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  maxlength="4"
                  size="small"
                  placeholder=""
                ></el-input
                >px
              </span>
            </div>
            <p>（分辨率 最大为 2048px*2048px ，最小为 64px*64px ）</p>
            <div class="parameter parameter-size">
              <span>大小：</span>
              <span>
                <el-input
                  v-model="parameter.minSize"
                  @blur="onBlurParameterSize(parameter.minSize)"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  maxlength="4"
                  size="small"
                  placeholder=""
                ></el-input
                >—<el-input
                  v-model="parameter.maxSize"
                  @blur="onBlurParameterSize(parameter.maxSize)"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  maxlength="4"
                  size="small"
                  placeholder=""
                ></el-input
                >KB
              </span>
            </div>
            <p class="p-size">（图片最大为4096KB ，最小为大于0KB）</p>
          </div>
        </template>
        <template v-slot:buttons>
          <el-button class="primary" @click="confirmImageFiltering"
            >确认</el-button
          >
        </template>
      </gat-popup>
      <!-- 上传图片提示 -->
      <model-training-upload-tips
        :modelType="modelType"
        :popupActive="popupActive"
        @confirmUploadTip="confirmUploadTip"
        @cancelPopup="cancelPopup"
        @uploadNoTipChange="uploadNoTipChange"
      ></model-training-upload-tips>
      <!--文件预览-->
      <file-preview
        :modelType="modelType"
        :fileUrl="fileUrl"
        :dialogvisibleview="dialogvisibleview"
        @onClickDialog="dialogvisibleview = false"
      ></file-preview>
      <!--引用数据集弹窗-->
      <dataset-popup
        :modelType="modelType"
        :modelDatasetName="datasetName"
        :modelDatasetId="activeDataset"
        :fileNumAll="Pictures.total"
        :drawerShow="drawerShow"
        @onDrawerShow="drawerShow = false"
        @getPictureList="getCurrentTabNavImgList"
      ></dataset-popup>
    </div>
  </div>
</template>

<script>

/**
 * DOM
 * :class="{'events-disable':isRelease ==1}" 已发布时，一些功能禁止点击
 * 
 * */ 
import GatPopup from '@/components/common/GatPopup'
import IconInfoHelp from '@/components/icons/typography/InfoHelp'
import IconLabel from '@/components/icons/typography/ToolLabel'
import IconDelete from '@/components/icons/typography/PopupClose'

import LabelRegion from '@/components/pretrain/LabelRegion'
import ImgSlider from '@/components/pretrain/ImgSlider'
import ModelTrainingUploadTips from '@/components/pretrain/ModelTrainingUploadTips.vue'
import FilePreview from '@/components/pretrain/FilePreview.vue'
import DatasetPopup from '@/components/pretrain/DatasetPopup.vue'
import TooltipBox from '@/components/common/TooltipBox'

import COMMON from '@/axios/common/common.js'
import PRETRAIN from '@/axios/pretrain/pretrain.js'
import { debounce } from 'lodash' // 引入lodash数组函数方法
import { GetVerifyImgs } from '@/assets/js/mixin/mixinGetVerifyImgs.js'

export default {
  name: 'dataset-label',
  mixins: [GetVerifyImgs],
  components: {
    GatPopup,
    IconInfoHelp,
    IconLabel,
    IconDelete,
    LabelRegion,
    ImgSlider,
    ModelTrainingUploadTips,
    FilePreview,
    DatasetPopup,
    TooltipBox,
  },
  props: [],
  data() {
    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 新UC头像基地址
      fileUrl: '',
      conditionNav: ['全部', '符合条件', '不符合条件'],
      selectCondition: 0,
      isQualifiedSelected: false, // 图片置灰膜层
      checkList: ['1'],
      checked: null,
      parameter: {
        maxWidth: '',
        minWidth: '',
        maxHeight: '',
        minHeight: '',
        maxSize: '',
        minSize: '',
      },
      labelParameterList: [],
      DatasetList: [],
      versionList: [],
      origin: null,
      originTemp: null,
      isRelease:null,
      activeDataset: '',
      datasetName: '',
      Label: {
        records: [],
        current: 1,
        size: 30,
        total: 0,
      },
      activeLabel: [],
      Pictures: {
        // records: [],
        records: null,
        size: 7,
        current: 1,
        total: 0,
      },
      activeImage: void 0,
      ImgTag: {
        records: [],
        size: 999,
        current: 1,
        total: 0,
      },
      filterOptions: {
        filtered: 'tag',
        items: {
          tag: {
            name: 'tag',
            label: '标注状态',
            filteredId: [2],
            data: [
              {
                id: 2,
                label: '全部图片',
              },
              { id: 1, label: '已标注' },
              { id: 0, label: '未标注' },
            ],
          },
          label: {
            name: 'label',
            label: '标签筛选',
            filteredId: [],
            data: [],
          },
        },
      },
      // 当前图片是否标注了无目标
      noTarget: false,
      currentPage: 1, // 分页器当前页面
      currentPositionIndex: 0,
      activeImageIndex: 0,
      currentPosition: {
        index: -1,
        imgId: '',
      },
      display: 'label', // 显示模式
      // 弹窗
      popupActive: '',
      popupData: {
        labelName: '',
        delete: {
          imgId: '',
          index: -1,
        },
        rename: {
          flag: '',
          index: -1,
          value: '',
        },
        uploadNoTip: false,
      },
      Placeholder: {
        picture02: require('../../../public/images/pretrain/placeholder-picture-02.png'),
        labelImg01: require('../../../public/images/pretrain/label001.png'),
        labelImg02: require('../../../public/images/pretrain/label002.jpg'),
      },
      Example: {
        labelAllImg: require('../../../public/images/pretrain/example_label_all.png'),
        labelSimilarImg: require('../../../public/images/pretrain/example_label_similar.png'),
      },
      Icons: {
        InfoHelp: {
          iconName: '',
          viewBox: '0 0 36 36',
          width: '36',
          height: '36',
          // iconColor: "#fff"
        },
        edite: {
          iconName: '修改',
          viewBox: '0 0 17 17',
          width: '14',
          height: '14',
        },
        delete: {
          iconName: '删除',
          viewBox: '0 0 14 14',
          width: '14',
          height: '14',
          // iconColor: "#fff"}
        },
      },
      formdata: new FormData(),
      fullscreenLoading: null, // 加载效果
      activeImageFlng: true, //
      navCheckList: ['全选', '全不选', '反选'],
      currentNavlabel: '全选',
      getTagLabelIdsNum: 0,
      updateTagNum: 0,
      selentCurrentLabelId: '',
      labelPopupTitle: '添加标签',
      dialogvisibleview: false, // 预览文件弹窗
      drawerShow: false, // 引用数据集弹窗
    }
  },
  computed: {
    token() {
      return this.$store.state.token
    },
    modelType() {
      return this.$route.params.modeltype
    },
    filterOptData() {
      return this.filterOptions.items[this.filterOptions.filtered]
    },
    datasetOptions() {
      if (!this.DatasetList) {
        return []
      }

      return this.DatasetList.map((item) => {
        return { value: item.datasetName, label: item.datasetName }
      })
    },
    // versionOptions() {
    //   if (!this.versionList) {
    //     return []
    //   }

    //   return this.versionList.map((item) => {
    //     return { value: item.value, label: item.text }
    //   })
    // },
    regionImage() {
      if (!this.activeImage) {
        return {}
      }

      return this.Pictures.records &&
        this.Pictures.records[this.activeImage.index]
        ? this.Pictures.records[this.activeImage.index]
        : {}
    },
    regionLabel() {
      return this.Label.records
    },
  },
  watch: {
    token() {
      this.getDatasetPageList()
    },
    datasetName(name) {
      // 重新初始化
      if (this.origin) {
        //origin=='modelList'场景时的判断
        this.ifIsRelease()
        this.origin = null
      } else {
        this.activeDataset = ''
      }
      this.getVersionList(name)
    },
    activeDataset(val) {
      // 重新初始化，如果没有重新初始化，会沿用上一个数据集内容
      this.displayChange(this.display, 1)

        console.log('activeDataset', val)

      this.activeLabel = [2]
      this.filterOptions.filtered = 'tag'
      this.filterOptions.items[this.filterOptions.filtered].filteredId = [2]

      this.ifIsRelease()

      this.getLabelList().then(() => {
        this.getPictureList()
        this.getLabelFilterOptions()
      })
    },
    activeLabel(val) {
      this.getCurrentTabNavImgList() // 查询当前导航栏标签图片列表
    },
    'filterOptions.filtered'(val) {
      this.activeImage.index = 0
    },
    Pictures(Pictures) {
      var index =
        this.activeImage && this.activeImage.index ? this.activeImage.index : 0
      this.currentPage = Pictures.current
      if (this.display === 'label') {
        this.currentPositionIndex = this.currentPage
      }

      if (Pictures.records) {
        if (Pictures.records.length < index + 1) {
          index = 0
        }
      } else {
        index = -1
      }

      this.activeImage = {
        imgId:
          Pictures.records && Pictures.records[index]
            ? Pictures.records[index].imgId
            : '',
        index: index,
      }
    },
    activeImage() {
      // 减少多次调用接口
      if (this.activeImageFlng) {
        this.activeImageFlng = false
        setTimeout(() => {
          // 获取激活图片的标记
          this.getImgTag()
          this.activeImageFlng = true
        }, 100)
      }
      this.currentNavlabel = '全选'
    },
    display(mode) {
      this.displayChange(mode)
      if (!this.activeDataset) {
        return
      }
      let pageIndex = 0,
        total = 0
      if (mode === 'picture') {
        // picture：展开多行列表
        if (this.currentPositionIndex > this.currentPage) {
          this.currentPage = this.currentPositionIndex
        }
        this.currentPositionIndex = this.currentPage // 展开多行页面存储单行页码
        localStorage.labelCurrentPage = this.currentPage
        total = (this.currentPage - 1) * 7 + this.activeImage.index + 1
        pageIndex = Math.ceil(total / 20)
        this.getCurrentTabNavImgList(pageIndex) // 查询当前导航栏标签图片列表
        // 清除文件定位
        this.currentPosition = {
          index: -1,
          imgId: '',
        }
        this.activeImageIndex = this.activeImage.index // 展开多行页面存储单行当前下标
      } else {
        // label：展开单行列表
        if (this.currentPosition && this.currentPosition.imgId) {
          // 通过定位展开单行列表
          total = (this.currentPage - 1) * 20 + this.currentPosition.index + 1
          pageIndex = Math.ceil(total / 7)
          this.activeImage = {
            index: Math.floor((total - 1) % 7),
            imgId: this.currentPosition.imgId,
          }
          this.currentPositionIndex = pageIndex
        } else {
          // 通过收起多行列表按钮 展开单行列表
          pageIndex = Number(localStorage.labelCurrentPage)
          if (this.activeImageIndex > this.activeImage.index) {
            this.activeImage.index = this.activeImageIndex
          }
        }
        this.getCurrentTabNavImgList(pageIndex) // 查询当前导航栏标签图片列表
      }
    },
  },
  mounted() {
    this.localStorageUploadTip()

    if (this.$route.query.datasetId) {
      this.datasetName = this.$route.query.datasetName
      this.origin = this.$route.query.origin
      this.originTemp = this.origin
      // 因引用数据集返回延迟-获取数据集id处理
      this.getVersionList(this.datasetName).then(() => {
        this.activeDataset = this.$route.query.datasetId
      })
    }
    if (this.$route.params.datasetId) {
      this.datasetName = this.$route.params.datasetName
      this.activeDataset = this.$route.params.datasetId
      this.origin = this.$route.params.origin
      this.originTemp = this.origin
    }

    if (this.token) {
      this.getDatasetPageList().then(() => {
        if (this.activeDataset) {
          this.getLabelList().then(() => {
            this.getPictureList()
          })
        }
      })
    }
  },
  methods: {
    // 预览图片
    onFilePreview(imgUrl) {
      this.fileUrl = this.photoBaseUrl + imgUrl
      this.dialogvisibleview = true
    },
    // 标签状态设置全选
    setLabelStateAll() {
      this.Label.records.forEach((item) => {
        item.labelState = true
      })
    },
    // 标签全选、全不选、反选
    onSelectNavState(val) {
      this.currentNavlabel = val
      if (val === '全选') {
        this.setLabelStateAll() // 标签状态设置全选
      } else if (val === '全不选') {
        this.Label.records.forEach((item) => {
          item.labelState = false
        })
      } else {
        // 反选
        this.Label.records.forEach((item) => {
          item.labelState = !item.labelState
        })
      }
      this.$forceUpdate() // 强制更新数据
      this.getImgTag() // 获取标注
    },
    // 勾选标签标注展示状态
    onSelectLabel(labelId) {
      this.Label.records.forEach((item) => {
        if (item.labelId === labelId) {
          item.labelState = !item.labelState
        }
      })

      this.$forceUpdate() // 强制更新数据
      this.getImgTag() // 获取标注
    },
    // 图片勾选
    handleChecked(item, index) {
      let data = {
        imgId: item.imgId, // 图片id
        isQualified: item.isQualified, // 图片是否符合条件：0为符合；1为不符合
      }

      // 修改图片是否符合条件状态
      PRETRAIN.updateImgIsQualifiedByImgId(data).then((result) => {
        if (result.isSuccess) {
          this.getCurrentTabNavImgList(this.Pictures.current) // 查询当前导航栏标签图片列表
        } else {
          this.$message.error(result.returnMsg)
        }
      })

      this.$forceUpdate() // 强制刷新数据
    },
    // 条件单选
    onSelectRadio(val) {
      this.selectCondition = val
      // 判断当前的筛选进行数据获取
      this.getCurrentTabNavImgList() // 查询当前导航栏标签图片列表
      this.setLabelStateAll() // 标签状态设置全选
    },

    // 查询当前导航栏标签图片列表
    getCurrentTabNavImgList(pageIndex) {
      let filtered = this.filterOptions.filtered
      if (filtered === 'tag') {
        // 根据数据集id查询图片列表
        this.getPictureList(pageIndex)
      } else if (filtered === 'label') {
        // 根据数据集id查询图片列表
        this.getPictureListByLabel(pageIndex)
        this.getTagNumByLabelIds() // 根据标签id查询标注数量
      }
    },

    // 获取数据集列表
    getDatasetPageList() {
      let data = {
        type: this.modelType,
      }

      return new Promise((resolve, reject) => {
        PRETRAIN.selectDataset(data).then((result) => {
          if (result.isSuccess) {
            this.DatasetList = result.data
            resolve(result.data)
          } else {
            reject(result)
          }
        })
      })
    },
    // 获取版本列表
    getVersionList(datasetName) {
      let data = {
        type: this.modelType,
        datasetName,
      }
      return new Promise((resolve, reject) => {
        PRETRAIN.selectDatasetVersion(data).then((result) => {
          if (result.isSuccess) {
            this.versionList = result.data
             //origin=='dataList'场景时的判断
           this.ifIsRelease()
            resolve(result.data)
          } else {
            reject(result)
          }
        })
      })
    },
     //判断数据集版本是否已发布
    ifIsRelease(orgin) {
      let { origin, activeDataset, versionList } = this
      if (origin == 'modelList') {
        this.isRelease = 1
      } else if (versionList.length ) {
        versionList.forEach((item) => {
          if (item.datasetId == activeDataset) {
            this.isRelease = item.isRelease
          }
        })
      }
    },
    // 标签处理，标签最多 20 个
    // Label
    getLabelList() {
      var datasetId = this.activeDataset,
        data = {
          datasetId: datasetId,
          modelType: this.modelType,
        }
      // debugger;
      return new Promise((resolve, reject) => {
        PRETRAIN.getLabelByDatasetId(data).then((result) => {
          if (result.isSuccess) {
            let records = JSON.parse(JSON.stringify(this.Label.records))
            this.Label.records = result.data

            if (this.currentNavlabel === '全选') {
              this.Label.records.forEach((item) => {
                item.labelState = true
              })
            } else if (this.currentNavlabel === '全不选') {
              this.Label.records.forEach((item) => {
                item.labelState = false
              })
            } else {
              // 反选
              this.Label.records.forEach((item) => {
                records.forEach((i) => {
                  if (item.labelId === i.labelId) {
                    item.labelState = i.labelState
                  }
                })
              })
              if (this.labelPopupTitle == '添加标签') {
                this.Label.records[0].labelState = true
              }
            }
            // this.Label = result.data;
            // this.activeLabel = result.Data.records[0].labelId;
            resolve(result.data)
          } else {
            reject(result)
          }
        })
      })
    },
    // 格式化标签筛选选项
    getLabelFilterOptions() {
      if (!this.Label.records) {
        return
      }

      this.filterOptions.items.label.data = this.Label.records.map((item) => {
        return {
          id: item.labelId,
          label: item.labelName,
        }
      })
      this.filterOptions.items.label.data.unshift({
        id: 'all_picture',
        label: '全部图片',
      })
    },
    // 添加标签
    activeAddTagPopup() {
      this.labelPopupTitle = '添加标签'
      if (!this.activeDataset) {
        return this.$message.warning('请选择数据集再进行标签操作')
      }

      // 最多能创建 20 个标签分类
      if (this.Label.records && this.Label.records.length >= 20) {
        return this.$message.warning('最多只能创建 20 个标签分类')
      }

      this.popupData.labelName = ''
      this.popupActive = 'add_tag'
    },
    // 检测标题命名值
    checkLabelValue(value) {
      var result = false
      // eslint-disable-next-line no-useless-escape
      if (!/^[\u4e00-\u9fa5\_A-Za-z0-9]+$/.test(value)) {
        this.$message.error('标签名称只能由汉字、字母、数字组成')
        result = true
      }
      return result
    },
    // 创建标签
    addLabel() {
      var datasetId = this.activeDataset,
        labelName = this.popupData.labelName,
        data = {
          labelName: labelName,
          datasetId: datasetId,
        }

      // 标签命名检测，只能由汉字、字母、数字组成
      if (this.checkLabelValue(labelName)) {
        return
      }

      PRETRAIN.addLabel(data).then(async (result) => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg)
          this.cancelPopup() // 关闭弹窗
          if (!this.Label.records) {
            this.Label.records = []
          }
          await this.getLabelList() //筛选标签列表更新
          this.getLabelFilterOptions() // 筛选标签列表更新
          this.popupData.labelName = '' // 清除缓存
        } else {
          this.$message.error(result.returnMsg)
        }
      })
    },
    // 标签重命名
    activeRenameLabelPopup(index, labelId, labelName) {
      this.labelPopupTitle = '编辑标签'
      this.popupActive = 'rename'
      this.popupData.rename.index = index
      this.popupData.rename.value = labelName
      this.popupData.rename.flag = 'label'
    },
    renameLabel() {
      // if (!this.popupData.rename.value) {
      //   return this.$message.error('重命名不能为空！');
      // }
      // 标签命名检测，只能由汉字、字母、数字组成
      if (this.checkLabelValue(this.popupData.rename.value)) {
        return
      }
      var index = this.popupData.rename.index,
        labelName = this.popupData.rename.value,
        label = this.Label.records[index],
        labelId = label.labelId,
        oldlabelName = label.labelName,
        datasetId = label.datasetId,
        data = {}

      data = {
        labelName: labelName,
        labelId: labelId,
        datasetId: datasetId,
      }

      PRETRAIN.updateLabelBylabelId(data).then((result) => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg)
          let iLabel = this.Label
          iLabel.records[index].labelName = labelName
          this.Label = iLabel
          this.getLabelFilterOptions() // 筛选标签列表更新
          this.cancelPopup()
          // 标记区域重命名
          this.$refs.labelRegion.renameRegionLabel(labelName, oldlabelName)
        } else {
          this.$message.error(result.returnMsg)
        }
      })
    },
    // 删除标签弹窗
    deleteLabelPopup(index, labelId) {
      this.popupActive = 'label_delete'
      this.popupData.delete.index = index
    },
    // 删除标签
    deleteLabel(/*index, labelId*/) {
      var index = this.popupData.delete.index,
        label = this.Label.records[index],
        labelId = label.labelId,
        labelName = label.labelName,
        datasetId = label.datasetId,
        data = {},
        data2 = {}

      data = {
        labelName: labelName,
        labelId: labelId,
        datasetId: datasetId,
        datasetType: 2,
      }
      data2 = {
        datasetId: datasetId,
      }

      // 先把图片里面的标注删除，然后把标签删除
      PRETRAIN.deleteLabelBylabelId(data).then((result) => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg)
          // 关闭弹窗
          this.cancelPopup()
          PRETRAIN.getLabelByDatasetId(data2).then((res) => {
            if (res.isSuccess) {
              // 标签筛选选中处理
              let type = this.filterOptions.filtered,
                options = JSON.parse(JSON.stringify(this.filterOptions)),
                filteredIds = options.items[type].filteredId

              filteredIds.forEach((itm, idx) => {
                if (itm === labelId) {
                  filteredIds.splice(idx, 1) // 删除的标签从选中标签中去除
                }
              })
              this.filterOptions.items[type].filteredId = filteredIds
              this.activeLabel = filteredIds

              this.Label.records.splice(index, 1) // 从标签列表删除标签
              this.getLabelFilterOptions() // 筛选标签列表更新
              setTimeout(() => {
                this.sliderImageHandle(
                  this.activeImage,
                  this.activeImage.index,
                  'deleteLabel'
                ) // 更新图片标注
              }, 500)

              // 删除标签透同步删除标记区域
              this.$refs.labelRegion.deleteRegionLabel(labelName)
            } else {
              this.$message.error(res.returnMsg)
            }
          })
        } else {
          this.$message.error(result.returnMsg)
        }
      })
    },

    // 根据标签id查询标注数量
    getTagNumByLabelIds() {
      var datasetId = this.activeDataset,
        data = {},
        activeLabel = JSON.parse(JSON.stringify(this.activeLabel)),
        labels = activeLabel.map((item) => {
          return item
        })

      if (!this.activeDataset /*|| this.activeLabel.length <= 0*/) {
        return
      }

      // 全部图片
      if (activeLabel.includes('all_picture')) {
        labels = []
      }

      data = {
        datasetId: datasetId, // 数据集id
        datasetType: this.modelType, // 数据集类型（同模型类型：modelType）
        isQualified: this.selectCondition, // 条件筛选 0：全部；1:符合条件；2:不符合条件
        labelIdList: labels, // 标签id集合
      }

      PRETRAIN.getTagNumByLabelIds(data).then((result) => {
        if (result.isSuccess) {
          this.getTagLabelIdsNum = result.data
        }
      })
    },

    // 根据数据集id查询图片列表
    // tips:图片分类中，需要数据集和分类标签完备情况下使用
    getPictureList(pageIndex) {
      var pageIndex_ = pageIndex ? pageIndex : 1,
        pageSize = this.Pictures.size,
        data = {}

      if (!this.activeDataset) {
        return
      }

      data = {
        datasetId: this.activeDataset,
        pageNum: pageIndex_,
        pageSize: pageSize,
        isQualified: this.selectCondition,
      }

      // TODO:此处可优化
      if (this.activeLabel.length > 0) {
        if (this.filterOptions.filtered === 'tag') {
          data.isTag = this.activeLabel[0]
        }
      }

      return new Promise((resolve, reject) => {
        PRETRAIN.getImgByDatasetId(data).then((result) => {
          if (result.isSuccess) {
            this.Pictures = result.data
            this.Pictures.records.forEach((item) => {
              if (item.isQualified == 0) {
                item.checked = true
              } else {
                item.checked = false
              }
            })
            // 当前页没有图片回调去到上一页
            if (
              this.Pictures.current > 1 &&
              this.Pictures.records.length === 0
            ) {
              let currentPageNum = this.Pictures.current - 1
              this.getPictureList(currentPageNum)
            }
            resolve(result.data)
          } else {
            reject(result)
          }
        })
      })
    },

    // 通过标签标注获取图片
    getPictureListByLabel(pageIndex) {
      var token = this.token,
        pageIndex_ = pageIndex ? pageIndex : 1,
        pageSize = this.Pictures.size,
        datasetId = this.activeDataset,
        data = {},
        activeLabel = JSON.parse(JSON.stringify(this.activeLabel)),
        labels = activeLabel.map((item) => {
          return item
        }),
        filterOptions

      if (!this.activeDataset /*|| this.activeLabel.length <= 0*/) {
        return
      }

      // 全部标记
      // if(activeLabel.includes("all_label")){
      //   filterOptions = JSON.parse(JSON.stringify(this.filterOptions.items.label.data));
      //   filterOptions.shift();
      //   labels = filterOptions.map(item => {
      //     return {
      //       labelId: item.id
      //     }
      //   })
      // };

      // 全部图片
      if (activeLabel.includes('all_picture')) {
        labels = []
      }

      data = {
        labelIdList: labels,
        datasetId: datasetId,
        pageNum: pageIndex_,
        pageSize: pageSize,
        isQualified: this.selectCondition,
      }

      return new Promise((resolve, reject) => {
        PRETRAIN.getImgByLabelIdList(data).then((result) => {
          if (result.isSuccess) {
            this.Pictures = result.data
            this.Pictures.records.forEach((item) => {
              if (item.isQualified == 0) {
                item.checked = true
              } else {
                item.checked = false
              }
            })
            // 当前页没有图片回调去到上一页
            if (
              this.Pictures &&
              this.Pictures.current > 1 &&
              this.Pictures.records.length === 0
            ) {
              let currentPageNum = this.Pictures.current - 1
              this.getPictureListByLabel(currentPageNum)
            }
            resolve(result.data)
          } else {
            reject(result)
          }
        })
      })
    },

    // 摄像头采集
    onCameraAcquisition() {
      navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
      if(navigator.getUserMedia) {
        console.log("支持调取摄像头麦克风")

        let videoNum = 0;
        let microphoneNum = 0;
        navigator.mediaDevices.enumerateDevices().then(devices =>{
        	devices.forEach(device =>{
        		// console.log(device);
        		if (device.kind === "videoinput") { // 摄像头
              videoNum++
            };
        		if (device.kind === "audioinput") { // 麦克风
              microphoneNum++
            };
        	});
          // 检测是否有摄像头、麦克风
          if (videoNum) {
            this.$router.push({
              name: "camera-collection-img",
              query: {
                pageType: '1', // 页面类型：1模型训练，2数据集大厅
                modelType: this.modelType,
                fileNumAll: this.Pictures.total,
                datasetId: this.activeDataset,
                datasetName: this.datasetName,
              }
            })
          } else {
            this.$message.error('捕获摄像头失败，请重新安装摄像头！');
          }
        }).catch(function(err) {
          this.$message.error(err.name + ": " + err.message);
        });
      } else {
        this.$message.error('抱歉不支持调取摄像头');
      }
    },
    // 引用数据集
    quoteDataset() {
      this.drawerShow = true // 打开数据集弹窗
    },
    // 图片上传
    uploadPictures() {
      if (this.Pictures.total >= 3000) {
        return this.$message.error('单个数据集的图片总数不超过3000个哦~')
      }
      // TODO: 数据集选定、分类标签选定
      if (!this.popupData.uploadNoTip) {
        // 图片限制数据提示弹窗
        this.activeUploadTipPopup()
      } else {
        // 直接上传
        this.uploadPicturesToDataset()
      }
    },
    // 上传图片到相应标签的数据集中
    uploadPicturesToDataset() {
      var uploadFileNode = document.createElement('input') // 创建上传按钮
      var fileList = [] // 文件列表
      var self = this

      uploadFileNode.setAttribute('type', 'file') // 设置上传按钮属性
      uploadFileNode.setAttribute('multiple', 'ture') // 多文件上传
      uploadFileNode.setAttribute('accept', 'image/jpeg, image/jpg') // 限制图片除外的文件上传
      // uploadFileNode.setAttribute("accept", "image/*"); // 限制图片除外的文件上传
      // uploadFileNode.setAttribute("enctype", "multipart/form-data;"); // 编码方式

      uploadFileNode.click() // 触发上传事件

      // 上传进程
      uploadFileNode.onchange = function uploadChange(evt) {
        var formdata = new FormData(), 
          list,
          formatPass = true

        // 文件装配
        fileList = evt.target.files
        // 如果存在不是 image/jpeg 格式的图片就会触发停止上传的操作
        // jpg/jpeg 是一样，同属于 image/jpeg 格式
        list = Array.from(fileList)

        if (list.length > 200) {
          return self.$message.error('上传失败，单次上传图片限制200个!')
        }

        if (self.Pictures.total + list.length > 3000) {
          return self.$message.error(
            '上传失败，单个数据集的图片总数不超过3000个哦~'
          )
        }

        self.fullscreenLoading = self.$loading({
          lock: true,
          text: '图片上传中请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })

        self.noFile = 0;
        list.forEach((item, index) => {
          // self.selectUploadPicSize(item, list, index);
          let typeFlag = self.$util.filesFormatCheck(item, "jpg|jpeg"); // 检验文件类型
          if (typeFlag) {
            self.noFile++
            self.$message.error(`${item.name}上传失败，只允许上传 jpg/jpeg 格式图片！`);
          } else {
            formdata.append('file', item);
          }
        });

        if (list.length === self.noFile) {
          return self.fullscreenLoading.close(); // 关闭Loading
        }

        self.UploadMultipleFileApi(formdata); // 上传图片接口调用
      }
    },
    // async selectUploadPicSize(ev, arrList, index) {
    //   var self = this
    //   var uploadFile = ev

    //   if (uploadFile) {
    //     if (window.FileReader) {
    //       var fr = new FileReader()
    //       fr.onloadend = await async function(e) {
    //         let typeFlag = self.$util.filesFormatCheck(uploadFile, 'jpg|jpeg') // 检验文件类型
    //         if (typeFlag) {
    //           self.noFile++
    //           self.$message.error(
    //             `${uploadFile.name}上传失败，只允许上传 jpg/jpeg 格式图片！`
    //           )
    //         } else {
    //           // 声明新Image
    //           var img = new Image()
    //           // 此处不做任何压缩直接读取文件流显示为图片（可扩展为压缩图片后显示）
    //           img.src = e.target.result
    //           img.onload = await function() {
    //             // 图片格式大小尺寸区间
    //             if (uploadFile.size > 4194304) {
    //               self.noFile++
    //               self.$message.error(
    //                 `上传失败，图片名称为${uploadFile.name}格式过大！`
    //               )
    //             } else if (this.width > 2048 || this.height > 2048) {
    //               self.noFile++
    //               self.$message.error(
    //                 `上传失败，图片名称为“${uploadFile.name}”分辨率大于2048px*2048px！`
    //               )
    //             } else if (this.width < 64 || this.height < 64) {
    //               self.noFile++
    //               self.$message.error(
    //                 `上传失败，图片名称为“${uploadFile.name}”分辨率小于64px*64px！`
    //               )
    //             } else {
    //               self.formdata.append('file', uploadFile)
    //             }
    //           }
    //         }

    //         if (arrList.length === index + 1) {
    //           setTimeout(() => {
    //             if (arrList.length === self.noFile) {
    //               return self.fullscreenLoading.close() // 关闭Loading
    //             }
    //             self.UploadMultipleFileApi() // 上传图片接口调用
    //           }, 1000)
    //         }
    //       }
    //       fr.readAsDataURL(uploadFile)
    //     }
    //   }
    // },
    // 上传图片接口调用
    UploadMultipleFileApi(formdata) {
      COMMON.UploadMultipleFile(formdata).then((result) => {
        if (result.returnCode == 200) {
          let dataList = JSON.parse(JSON.stringify(result.data));
          let imgList = [];
          dataList.forEach((item, index) => {
            // 图片格式大小尺寸区间
            if (item.size && item.size > 4194304) {
              setTimeout(() => {
                this.$message.error(`上传失败，图片名称为${item.fileName}格式过大！`);
              }, index*5);
            } else if (item.width&&item.width > 2048 || item.height&&item.height > 2048 ) {
              setTimeout(() => {
                this.$message.error(`上传失败，图片名称为“${item.fileName}”分辨率大于2048px*2048px！`);
              }, index*5);
            } else if (item.width&&item.width < 64 || item.height&&item.height < 64) {
              setTimeout(() => {
                this.$message.error( `上传失败，图片名称为“${item.fileName}”分辨率小于64px*64px！`);
              }, index*5);
            } else {
              imgList.push(item);
            }
          });

          if (imgList.length === 0) {
            this.fullscreenLoading.close(); // 关闭Loading
            return
          }
          // 校验图片jpg|jpeg
          this.verifyImgs(imgList).then(res => {
            if (res.correct && res.correct.length) {
              let data = {
                datasetId: this.activeDataset,
                // labelId: this.activeLabel,
                datasetImgList: []
              }
              res.correct.forEach(i => {
                imgList.forEach(j => {
                  if (i.fileUrl.indexOf(`${j.url}`) !== -1) {
                    data.datasetImgList.push( {
                      imgUrl: j.url,
                      imgName: j.fileName,
                      imgWidth: j.width,
                      imgHeight: j.height,
                      imgSize: j.size,
                    });
                  }
                });
              });
              
              this.uploadImg(data); // 上传到服务器的文件转存到数据库中
            }
          })
        } else {
          this.$message.error(result.returnMsg)
          this.fullscreenLoading.close() // 关闭Loading
        }
      }).catch((error) => {
        this.fullscreenLoading.close() // 关闭Loading
        this.$message.error('上传失败!')
      })
    },
    // 存图片
    uploadImg(data) {
      // 上传到服务器的文件转存到数据库中
      PRETRAIN.uploadImgBylabelId(data).then((result) => {
        if (result.isSuccess) {
          // 上传成功
          this.$message.success(result.returnMsg)
          this.fullscreenLoading.close() // 关闭Loading
          // TODO:刷新图片数据
          this.getCurrentTabNavImgList() // 查询当前导航栏标签图片列表
        } else {
          this.$message.error(result.returnMsg)
          this.fullscreenLoading.close() // 关闭Loading
        }
      })
      .catch((error) => {
        this.fullscreenLoading.close() // 关闭Loading
      })
    },
    // 删除图片
    deletePicture() {
      if (this.popupActive === 'delete') {
        // 删除图片操作
        this.deleteImage()
      } else if (this.popupActive === 'label_delete') {
        // 删除标签操作
        this.deleteLabel()
      }
    },
    deleteImage() {
      var deleteIndex = this.popupData.delete.index,
        image = this.Pictures.records[deleteIndex],
        data = {
          imgId: image.imgId,
          imgName: image.imgName,
        }

      PRETRAIN.deleteImgByImgId(data).then((result) => {
        if (result.isSuccess) {
          this.$message.success('已删除图片：' + image.imgName)
          this.getCurrentTabNavImgList(this.Pictures.current) // 查询当前导航栏标签图片列表

          this.cancelPopup() // 关闭弹窗
        } else {
          this.$message.error(result.returnMsg)
        }
      })
    },
    // 图片重命名
    renamePicture() {
      if (!this.popupData.rename.value) {
        return this.$message.error('重命名不能为空！')
      }
      if (this.popupData.rename.value.length > 20) {
        return this.$message.error('重命名不能超过20个字符！')
      }

      let renameIndex = this.popupData.rename.index,
        imgName = this.popupData.rename.value,
        image = this.Pictures.records[renameIndex],
        imgId = image.imgId,
        datasetId = image.datasetId,
        data = {
          imgId: imgId,
          imgName: imgName,
        },
        list = []

      PRETRAIN.updateImgByImgId(data).then((result) => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg)
          list = JSON.parse(JSON.stringify(this.Pictures.records))
          list[renameIndex].imgName = imgName
          this.popupData.rename.imgName = ''
          this.Pictures.records = list
          this.cancelPopup() // 关闭弹窗
        } else {
          this.$message.error(result.returnMsg)
        }
      })
    },
    // 模型图片标注
    getImgTag() {
      if (!this.activeDataset) {
        return
      }
      var imgId = this.activeImage.imgId,
        datasetId = this.activeDataset,
        data = {
          imgId: imgId,
          datasetId: datasetId,
          labelIds: [],
        }

      this.Label.records.forEach((item) => {
        if (item.labelState) {
          data.labelIds.push(item.labelId)
        }
      })

      if (!imgId) {
        return
      }
      // 根据图片id查询图片标注数据 @data imgId 图片id labelId 标签id
      PRETRAIN.getImgTagByImgId(data).then((result) => {
        if (result.isSuccess) {
          if (result.data) {
            let dataArr = result.data
            // 将x1,x2,y1,y2转换为X1,X2,Y1,Y2
            dataArr.map((item) => {
              item.X1 = item.x1
              item.X2 = item.x2
              item.Y1 = item.y1
              item.Y2 = item.y2
              return item
            })
            this.ImgTag.records = dataArr //未有赋值
          } else {
            this.ImgTag.records = []
          }

          // 是否有 无目标设置 检测
          // this.noTarget = this.ImgTag.records && this.ImgTag.records.some(
          //   item => item.labelId === "00000000-0000-0000-0000-000000000000"
          // );
        }
      })
    },
    // 弹窗处理
    // 取消
    cancelPopup() {
      this.popupActive = ''
      // TODO: popupData 考虑是否要清除
    },
    // 标注示例
    activeExamplePopup() {
      this.popupActive = 'example'
    },
    // 删除
    activeDeletePopup(imgId, index) {
      this.popupActive = 'delete'
      this.popupData.delete.imgId = imgId
      this.popupData.delete.index = index
    },
    // 重命名
    activeRenamePopup(imgId, imgName, index) {
      this.popupActive = 'rename'
      this.popupData.rename.flag = 'picture'
      this.popupData.rename.value = imgName
      this.popupData.rename.index = index
    },
    renameOperate() {
      // 在弹窗数据中，存放 flag
      if (this.popupData.rename.flag === 'label') {
        this.renameLabel()
      } else if (this.popupData.rename.flag === 'picture') {
        this.renamePicture()
      }
    },
    // 图片上传说明
    activeUploadTipPopup() {
      this.popupActive = 'uploadtip'
    },
    // 上传提示显示后再进行上传操作
    confirmUploadTip() {
      // 图片上传说明确认
      this.cancelPopup()
      // TODO:上传图片事件触发
      this.uploadPicturesToDataset()
    },
    uploadNoTipChange(val) {
      this.localStorageUploadTip('save', val)
    },
    // 图片上传说明是否显示存储
    localStorageUploadTip(type, value) {
      if (type === 'save') {
        this.popupData.uploadNoTip = value
        window.localStorage.setItem('__upload_label_tip__', value)
      } else {
        let uploadNoTip = window.localStorage.getItem('__upload_label_tip__')
        this.popupData.uploadNoTip = uploadNoTip ? uploadNoTip : false
      }
    },
    // 筛选方式获取
    getFilterType(type) {
      this.filterOptions.filtered = type

      this.activeLabel = this.filterOptions.items[
        this.filterOptions.filtered
      ].filteredId

      this.getTagNumByLabelIds() // 根据标签id查询标注数量
      this.getTagLabelIdsNum = 0
      this.setLabelStateAll() // 标签状态设置全选
    },
    // 筛选详细
    getFilterDetails(filterId) {
      var type = this.filterOptions.filtered,
        options = JSON.parse(JSON.stringify(this.filterOptions)),
        filteredIds = options.items[this.filterOptions.filtered].filteredId,
        currentFileterIdx = filteredIds.findIndex((item) => item === filterId)

      // 情形分管
      if (type === 'label') {
        // 标签筛选
        if (currentFileterIdx <= -1) {
          filteredIds[filteredIds.length] = filterId
        } else {
          filteredIds.splice(currentFileterIdx, 1)
        }
        options.items[this.filterOptions.filtered].filteredId = filteredIds
        this.filterOptions = options

        this.activeLabel = filteredIds
      } else if (type === 'tag') {
        // 图片筛选
        options.items[this.filterOptions.filtered].filteredId[0] = filterId
        this.filterOptions = options

        this.activeLabel = [filterId]
      }

      this.getTagNumByLabelIds() // 根据标签id查询标注数量
      this.setLabelStateAll() // 标签状态设置全选
    },
    // 移除筛选详细
    removeFilterDetails(idx, filterId) {
      // item.id
      var type = this.filterOptions.filtered,
        options = JSON.parse(JSON.stringify(this.filterOptions)),
        filteredIds = options.items[this.filterOptions.filtered].filteredId,
        currentFileterIdx = filteredIds.findIndex((item) => item === filterId)

      if (type === 'label') {
        if (currentFileterIdx > -1) {
          filteredIds.splice(currentFileterIdx, 1)

          options.items[this.filterOptions.filtered].filteredId = filteredIds
          this.filterOptions = options

          this.activeLabel = filteredIds
        }
      } else if (type === 'tag') {
        options.items[this.filterOptions.filtered].filteredId[0] = 2
        this.filterOptions = options

        this.activeLabel = [2]
      }
    },
    // 把标签添加到当前区域
    addTagToCurrentRegion(labelName, labelId, labelData) {
      if (labelName !== '无目标') {
        this.selentCurrentLabelId = labelId
        this.$refs.labelRegion.addLabelSelect(labelData) // 调用选中标签
      }
      // 没有图片时，不做处理
      if (!this.activeImage) {
        return
      }

      if (labelName === '无目标') {
        // if (this.ImgTag.records.length && this.ImgTag.records[0].labelName && labelId) { // 判断图片有标注并且取消设置为无目标
        //   this.getImgTag(); // 获取图片标注
        // }
        if (this.noTarget) {
          // this.ImgTag.records = this.localPosition
          this.$refs.labelRegion.emptyTagRegion('')
        } else {
          // let position = this.$refs.labelRegion.stypeToPosition()
          // this.localPosition = JSON.parse(JSON.stringify(position))
          this.$refs.labelRegion.emptyTagRegion(labelName) // 清空标注
        }
        this.noTarget = !labelId
        // this.$refs.labelRegion.emptyTagRegion(labelName); // 清空标注
        this.$forceUpdate()
      }
    },
    // 上传标签标注
    updateLabelTag() {
      if (this.updateTagNum === 0) {
        // 判断连接点击多次保存只执行第一次
        this.updateLabelTagToOne()
      }
      this.updateTagNum++
    },
    // 00000000-0000-0000-0000-000000000000
    updateLabelTagToOne() {
      var position = this.$refs.labelRegion.stypeToPosition(),
        imgId = this.activeImage.imgId,
        data = { list: [] }

      position.forEach((item) => {
        let labelId = this.findLabelBylabelName(item.label).labelId,
          positionList = {
            x1: item.X1, // 坐标x1
            x2: item.X2, // 坐标x2
            y1: item.Y1, // 坐标y1
            y2: item.Y2, // 坐标y2
            imgId: imgId, // 图片id
            labelId: labelId, // 标签id
          }

        data.list.push(positionList) // 追加多个标注
      })

      data.imgId = imgId
      // 根据图片id标注图片
      PRETRAIN.updateImgTagByImgId(data)
        .then((result) => {
          if (result.isSuccess) {
            this.$message.success('保存成功')

            let filtered = this.filterOptions.filtered
            if (filtered === 'tag') {
              // 标注状态
              if (
                this.activeLabel[0] === 0 ||
                (this.activeLabel[0] === 1 && position.length === 0)
              ) {
                // 未标注 || 已标注
                this.getCurrentTabNavImgList(this.Pictures.current) // 查询当前导航栏标签图片列表
              }
            } else if (filtered === 'label') {
              // 标签筛选
              if (
                this.activeLabel.length &&
                !this.activeLabel.includes('all_picture')
              ) {
                // 判断非全部图片（标签标注分类）
                this.getCurrentTabNavImgList(this.Pictures.current) // 查询当前导航栏标签图片列表
              }
            }

            if (this.noTarget) {
              // 清空标注状态
              this.localPosition = [] // 清空缓存标注
              this.noTarget = false
            }

            // 重新获取标注
            this.getImgTag()
          } else {
            this.$message.error(result.returnMsg)
          }
          this.updateTagNum = 0 // 重置保存点击次数
        })
        .catch((err) => {
          this.updateTagNum = 0 // 重置保存点击次数
        })
    },
    // 利用标注名获取标注 id
    findLabelBylabelName(labelName) {
      var label = {}
      if (labelName === '无目标') {
        label = { labelId: '00000000-0000-0000-0000-000000000000' }
      } else {
        label = this.Label.records.find(
          (label) => label.labelName === labelName
        )
      }
      return label
    },
    // 图片定位
    onPreviewPosition(imgId, index) {
      this.currentPosition = {
        index: index,
        imgId: imgId,
      }
      this.display = 'label'
    },
    // 图片滑动
    sliderPrev(/*direct , evt */) {
      let { Pictures } = this
      if (Pictures.current && Pictures.current > 1) {
        this.pageTurnApi(-1)
      }
      this.currentPositionIndex = this.currentPage
    },
    sliderNext(/*direct , evt */) {
      this.currentPositionIndex = this.currentPage
      if (
        this.Pictures.current &&
        this.Pictures.current < this.Pictures.pages
      ) {
        this.pageTurnApi(1)
      } else {
        return
      }
    },
    sliderImageHandle(image, index, deleteLabel) {
      this.activeImage = { imgId: image.imgId, index: index }
      if (image.isQualified == 1) {
        this.isQualifiedSelected = true
      } else {
        this.isQualifiedSelected = false
      }
      this.selentCurrentLabelId = '' // 清除选中标签背景
      this.$refs.labelRegion.addLabelSelect({}) // 调用选中标签：清除选中标签
      // this.noTarget = false
      this.noTargetFun(deleteLabel)
    },
    noTargetFun: debounce(function(type) {
      if (type === 'deleteLabel') {
        // this.noTarget = true;
      } else {
        this.noTarget = false
      }
    }, 500),
    pageTurnApi(type) {
      var key = 1 * type
      this.getCurrentTabNavImgList(this.Pictures.current + key) // 查询当前导航栏标签图片列表
    },
    // 分页器
    handleCurrentChange(pageIndex) {
      this.getCurrentTabNavImgList(pageIndex) // 查询当前导航栏标签图片列表
    },
    // 切换页面格式
    switchDisplayMode() {
      var mode = this.display
      this.display = mode === 'label' ? 'picture' : 'label'
    },
    displayChange(mode, init) {
      var display = {
          picture: { size: 20, current: 1 },
          label: {
            size: 7,
            current: 1,
          },
        },
        p = { records: [], total: 0 }

      if (init) {
        this.Pictures = Object.assign(p, display[mode])
      } else {
        Object.assign(this.Pictures, display[mode])
      }
    },

    // 图片筛选
    onImageFiltering() {
      this.popupActive = 'imageFiltering'
      this.parameter = {
        maxWidth: '',
        minWidth: '',
        maxHeight: '',
        minHeight: '',
        maxSize: '',
        minSize: '',
      }

      if (this.activeDataset) {
        let data = {
          behaviorType: 1, // 类型1为：获取图片筛选设置的参数
          datasetId: this.activeDataset, // 数据集id
        }
        // 查询图片设置参数
        PRETRAIN.getBehaviorByDatasetId(data).then((result) => {
          if (result.isSuccess && result.data !== null) {
            if (result.data.behaviorRecord) {
              let behaviorRecord = JSON.parse(result.data.behaviorRecord)
              this.parameter = {
                maxWidth:
                  behaviorRecord.imgWidthMax == 0
                    ? ''
                    : behaviorRecord.imgWidthMax,
                minWidth:
                  behaviorRecord.imgWidthMin == 0
                    ? ''
                    : behaviorRecord.imgWidthMin,
                maxHeight:
                  behaviorRecord.imgHeightMax == 0
                    ? ''
                    : behaviorRecord.imgHeightMax,
                minHeight:
                  behaviorRecord.imgHeightMin == 0
                    ? ''
                    : behaviorRecord.imgHeightMin,
                maxSize:
                  behaviorRecord.imgSizeMax == 0
                    ? ''
                    : behaviorRecord.imgSizeMax / 1024,
                minSize:
                  behaviorRecord.imgSizeMin == 0
                    ? ''
                    : behaviorRecord.imgSizeMin / 1024,
              }
            }
          }
        })
      }
    },
    // 图片筛选数据检验
    onBlurParameter(val) {
      if (val && val < 64) {
        this.$message.warning('低于最小分辨率64px，请修改分辨率参数！')
      }
      if (val && val > 2048) {
        this.$message.warning('超过最大分辨率2048px，请修改分辨率参数！')
      }
    },
    onBlurParameterSize(val) {
      if (val && val == 0) {
        this.$message.warning('图片最小不能为 0 KB，请修改图片大小参数！')
      }
      if (val && val > 4096) {
        this.$message.warning('超过4096KB图片过大，请修改图片大小参数！')
      }
    },
    // 确认图片筛选数据
    confirmImageFiltering() {
      if (
        !this.parameter.maxWidth &&
        !this.parameter.minWidth &&
        !this.parameter.maxHeight &&
        !this.parameter.minHeight &&
        !this.parameter.maxSize &&
        !this.parameter.minSize
      ) {
        return this.$message.warning('请输入图片分辨率或图片大小参数！')
      } else {
        if (
          this.parameter.maxWidth ||
          this.parameter.minWidth ||
          this.parameter.maxHeight ||
          this.parameter.minHeight
        ) {
          if (
            (this.parameter.maxWidth && this.parameter.maxWidth > 2048) ||
            (this.parameter.minWidth && this.parameter.minWidth > 2048) ||
            (this.parameter.maxHeight && this.parameter.maxHeight > 2048) ||
            (this.parameter.minHeight && this.parameter.minHeight > 2048)
          ) {
            return this.$message.warning(
              '超过最大分辨率2048px，请修改分辨率参数！'
            )
          }
          if (
            (this.parameter.maxWidth && this.parameter.maxWidth < 64) ||
            (this.parameter.minWidth && this.parameter.minWidth < 64) ||
            (this.parameter.maxHeight && this.parameter.maxHeight < 64) ||
            (this.parameter.minHeight && this.parameter.minHeight < 64)
          ) {
            return this.$message.warning(
              '低于最小分辨率64px，请修改分辨率参数！'
            )
          }
          if (
            !this.parameter.maxWidth ||
            !this.parameter.minWidth ||
            !this.parameter.maxHeight ||
            !this.parameter.minHeight
          ) {
            return this.$message.warning('请补全图片分辨率参数！')
          }
        }

        if (this.parameter.maxSize || this.parameter.minSize) {
          if (!this.parameter.maxSize || !this.parameter.minSize) {
            return this.$message.warning('请补全图片大小参数！')
          }
          if (this.parameter.maxSize > 4096 || this.parameter.minSize > 4096) {
            return this.$message.warning(
              '超过4096KB图片过大，请修改图片大小参数！'
            )
          }
          if (this.parameter.maxSize < 1 || this.parameter.minSize < 1) {
            return this.$message.warning(
              '图片最小不能为 0 KB，请修改图片大小参数！'
            )
          }
        }
      }

      let maxWidth = Number(this.parameter.maxWidth),
        minWidth = Number(this.parameter.minWidth),
        maxHeight = Number(this.parameter.maxHeight),
        minHeight = Number(this.parameter.minHeight),
        maxSize = Number(this.parameter.maxSize),
        minSize = Number(this.parameter.minSize)

      let imgWidthMax = maxWidth >= minWidth ? maxWidth : minWidth,
        imgWidthMin = minWidth <= maxWidth ? minWidth : maxWidth,
        imgHeightMax = maxHeight >= minHeight ? maxHeight : minHeight,
        imgHeightMin = minHeight <= maxHeight ? minHeight : maxHeight,
        imgSizeMax = maxSize >= minSize ? maxSize : minSize,
        imgSizeMin = minSize <= maxSize ? minSize : maxSize,
        params = {
          datasetId: this.activeDataset,
          imgWidthMax: imgWidthMax,
          imgWidthMin: imgWidthMin,
          imgHeightMax: imgHeightMax,
          imgHeightMin: imgHeightMin,
          imgSizeMax: imgSizeMax * 1024,
          imgSizeMin: imgSizeMin * 1024,
        }

      // 根据用户设置筛选图片
      PRETRAIN.screenImg(params).then((result) => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg)
          this.popupActive = ''
          this.getCurrentTabNavImgList(this.Pictures.current) // 查询当前导航栏标签图片列表
          this.setLabelStateAll() // 标签状态设置全选
        } else {
          this.$message.error(result.returnMsg)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import './pretrain_common.scss';
@import './DatasetLabel.scss';
</style>
